import * as React from "react";

interface Props {
    label?: string | JSX.Element;
}

type RadioProps = Props & React.InputHTMLAttributes<HTMLInputElement>;

interface AlignedProps {
    alignment: "center" | "top";
}

const inputClassName =
    "form-radio disabled:bg-gray-100 border-gray-400 hover:border-brand-600 active:border-brand-400 focus:ring-2 focus:ring-brand-300";

const AlignedRadio: React.FC<RadioProps & AlignedProps> = props => {
    const { label, className, alignment, ...rest } = props;
    const top = alignment === "top";
    return (
        <div className={`${className ?? ""} w-full`}>
            <label className={`flex ${top ? "items-start" : "items-center"}`}>
                <input
                    type="radio"
                    className={`${inputClassName} ${top ? "mt-1 shrink-0" : ""}`}
                    {...rest}
                />
                {label ? <div className="ml-2">{label}</div> : null}
            </label>
        </div>
    );
};

export const Radio: React.FC<RadioProps> = props => (
    <AlignedRadio alignment="center" {...props} />
);

export const TopAlignedRadio: React.FC<RadioProps> = props => (
    <AlignedRadio alignment="top" {...props} />
);
